<script>
import TextField from '@phoenix/mixins/components/form/fields/TextField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [TextField],

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <input
    :id="fieldUniqueId"
    :ref="field.id"
    v-model="value"
    :type="htmlType"
    :name="field.name"
    :class="customFieldClasses"
    :aria-describedby="ariaDescribedby"
    :aria-label="field.ariaLabel"
    :placeholder="field.placeholder"
    :disabled="field.disabled"
    :autocomplete="field.autocomplete ? 'on' : 'off'"
    :autocorrect="field.autocorrect ? 'on' : 'off'"
    :inputmode="inputmode"
    :pattern="pattern"
  />
</template>
